<ng-container *transloco="let t; prefix: 'mobile-mode-selector'">
  <div class="mobile-mode-selector">
    <div class="mobile-mode-selector__overlay"></div>
    <div class="mobile-mode-selector__dialog">
      <div class="mobile-mode-selector__header">
        <h1 class="mobile-mode-selector__title">{{ t('title') }}</h1>
        <p class="mobile-mode-selector__subtitle">{{ t('subtitle') }}</p>
      </div>

      <div class="mobile-mode-selector__options">
        <button type="button" class="mobile-mode-selector__option" (click)="selectMode('desktop')">
          <div class="mobile-mode-selector__option-icon">
            <xi-icon icon="desktop_windows" iconSize="large"></xi-icon>
          </div>
          <div class="mobile-mode-selector__option-content">
            <span class="mobile-mode-selector__option-title">{{ t('desktop-option') }}</span>
            <span class="mobile-mode-selector__option-desc">{{ t('desktop-description') }}</span>
          </div>
          <xi-icon icon="arrow_right" iconSize="medium" color="orca"></xi-icon>
        </button>

        <button
          type="button"
          class="mobile-mode-selector__option mobile-mode-selector__option--featured"
          (click)="selectMode('chat')"
        >
          <div class="mobile-mode-selector__option-icon">
            <xi-icon icon="chat" iconSize="large"></xi-icon>
          </div>
          <div class="mobile-mode-selector__option-content">
            <span class="mobile-mode-selector__option-title">{{ t('chat-option') }}</span>
            <span class="mobile-mode-selector__option-desc">{{ t('chat-description') }}</span>
          </div>
          <xi-icon icon="arrow_right" iconSize="medium"></xi-icon>
        </button>
      </div>
    </div>
  </div>
</ng-container>
